export type ActivityIndexScope = { siteId: string; year: number };
export type ActivityIndexSummary = ActivityIndexScope & (
  | { state: 'not-connected' | 'unconfigured'; annualTarget: null; completed: null }
  | { state: 'ready'; annualTarget: number; completed: number }
  | { state: 'incomplete'; annualTarget: number; completed: null }
);
/** Supplied by the future activity-plan feature; this dashboard never creates plans. */
export interface ActivityIndexReader {
  load(scope: ActivityIndexScope): Promise<unknown>;
}

export function parseActivityIndex(value: unknown, scope: ActivityIndexScope): ActivityIndexSummary {
  if (!value || typeof value !== 'object') throw Error('ACTIVITY_INDEX_RESPONSE_INVALID');
  const row = value as Record<string, unknown>;
  if (row.siteId !== scope.siteId || row.year !== scope.year) throw Error('ACTIVITY_INDEX_SCOPE_MISMATCH');
  if (row.state === 'unconfigured' && row.annualTarget === null && row.completed === null)
    return { ...scope, state: 'unconfigured', annualTarget: null, completed: null };
  if(row.state==='incomplete'&&Number.isSafeInteger(row.annualTarget)&&Number(row.annualTarget)>=0&&row.completed===null)
    return {...scope,state:'incomplete',annualTarget:Number(row.annualTarget),completed:null};
  if (row.state !== 'ready' || !Number.isSafeInteger(row.annualTarget) || Number(row.annualTarget) < 0 ||
      !Number.isSafeInteger(row.completed) || Number(row.completed) < 0)
    throw Error('ACTIVITY_INDEX_COUNT_INVALID');
  return { ...scope, state: 'ready', annualTarget: Number(row.annualTarget), completed: Number(row.completed) };
}

export async function loadActivityIndex(scope: ActivityIndexScope, reader?: ActivityIndexReader): Promise<ActivityIndexSummary> {
  if (!reader) return { ...scope, state: 'not-connected', annualTarget: null, completed: null };
  return parseActivityIndex(await reader.load(scope), scope);
}

export function activityAchievementPercent(summary: ActivityIndexSummary): number | null {
  return summary.state === 'ready' && summary.annualTarget > 0
    ? Math.round(summary.completed / summary.annualTarget * 1000) / 10 : null;
}
